/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicGameInfoModelDto } from '../../models/public-game-info-model-dto';

export interface GameTrackerPublicControllerGetGameInfo$Params {
  userUuid: string;
  localId: string;
  accessHash: string;
}

export function gameTrackerPublicControllerGetGameInfo(http: HttpClient, rootUrl: string, params: GameTrackerPublicControllerGetGameInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicGameInfoModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerPublicControllerGetGameInfo.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('localId', params.localId, {});
    rb.path('accessHash', params.accessHash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublicGameInfoModelDto>;
    })
  );
}

gameTrackerPublicControllerGetGameInfo.PATH = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/info';
